import { Axios } from "api/axios";
import LoaderErrorWrapper from "components/LoaderErrorWrapper/LoaderErrorWrapper";
import Colors from "Constants/Color";
import { tableStyles } from "Constants/Style";
import { api } from "helpers/api_url";
import React, { Fragment, useEffect, useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import OrderStatusBadge from "components/StatusBadge/OrderStatusBadge";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Table,
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ViewBagsModal from "./ViewBagsModal";
import PageContainer from "components/PageContainer/PageContainer";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import LoadingSpinner from "components/LoaderErrorWrapper/LoadingSpinner";
import TruncatedTextCell from "components/TruncatedTextCell/TruncatedTextCell";

const ViewReadyDispatchOrderDetails: React.FC = () => {
  document.title = "View Order";
  const { id } = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [error, setError] = useState<any>("");
  const [data, setData] = useState<any>({});
  const [viewBagsForItem, setViewBagsForItem] = useState<any[]>([]);

  const navigate = useNavigate();
  useEffect(() => {
    if (id) {
      setLoading(true);
      Axios.get(`${api?.order?.order_by_id}/${id}`)
        .then((result) => {
          setData(result?.data?.data || {});
        })
        .catch((err) => {
          toast.error("Failed to fetch Order data");
          setError("Failed to fetch Order data");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  return (
    <PageContainer>
      <>
        <FormHeader
          title="View Order"
          firstLabel="Order"
          secondLabel="View Order"
          handleArrowClick={() => navigate("/warehouse-dispatch")}
          handleBreadcrumbClick={() => navigate("/warehouse-dispatch")}
        />
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="mb-2">
              <hr />
              <h6
                className="mb-3"
                style={{ fontWeight: "600", color: "#212529" }}
              >
                Order Details
              </h6>
              <Row className="mb-0 mt-3">
                <Col lg={3} className="mb-2">
                  <div className="d-flex gap-1 align-items-center">
                    <span style={{ fontWeight: "500" }}>Order No.:</span>
                    <span style={{ color: "#212529" }}>
                      {data.order_no || "-"}
                    </span>
                  </div>
                </Col>
                <Col lg={3} className="mb-2">
                  <div className="d-flex gap-1 align-items-center">
                    <span style={{ fontWeight: "500" }}>Quotation No.:</span>
                    <span style={{ color: "#212529" }}>
                      {data?.quotation_no || "-"}
                    </span>
                  </div>
                </Col>
                <Col lg={3} className="mb-2">
                  <div className="d-flex gap-1 align-items-center">
                    <span style={{ fontWeight: "500" }}>Order Date:</span>
                    <span style={{ color: "#212529" }}>
                      {data?.order_date?.toString()?.split("T")[0] || "-"}
                    </span>
                  </div>
                </Col>

                <Col lg={3} className="mb-2">
                  <div className="d-flex gap-1 align-items-center">
                    <span style={{ fontWeight: "500" }}>Customer:</span>
                    <span style={{ color: "#212529" }}>
                      {data?.customer_details?.customer_name || "-"}
                    </span>
                  </div>
                </Col>
                <Col lg={6} className="mb-2">
                  <div className="d-flex gap-1 align-items-center">
                    <span style={{ fontWeight: "500" }}>
                      Dispatch From Warehouse:
                    </span>
                    <span style={{ color: "#212529" }}>
                      {data?.warehouse?.warehouse_name || "-"}
                    </span>
                  </div>
                </Col>
              </Row>

              <hr />
            </div>
            <div className="mb-3">
              <h6
                className="mb-3"
                style={{ fontWeight: "600", color: "#212529" }}
              >
                Item Details
              </h6>
              <div className="mb-2">
                <Table hover responsive className="align-middle text-center">
                  <thead>
                    <tr>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "80px" }}
                      >
                        Sr No.
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Category
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Sub Category
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Item Name
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Item Code
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Unit
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Quantity
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Bags
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Rate
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Amount
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Discount
                      </th>
                      {/* <th style={{ ...tableStyles.headerAlt, minWidth: "200px" }}>Discount Type</th> */}
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Discount Amount
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        GST%
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        GST Amount
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Total Amount
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Status
                      </th>
                      <th
                        style={{
                          ...tableStyles.headerAlt,
                          minWidth: "150px",
                        }}
                      >
                        Remarks
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Existing Rows */}
                    {data?.order_items?.length === 0 ? (
                      <tr>
                        <td
                          colSpan={15}
                          style={{ ...tableStyles.cell, textAlign: "center" }}
                          className="py-3"
                        >
                          No Items added. Please add at least one item.
                        </td>
                        <td
                          style={tableStyles.actionCell}
                          className="sticky-column"
                        ></td>
                      </tr>
                    ) : (
                      data?.order_items?.map((row: any, idx: number) => {
                        return (
                          <tr key={idx}>
                            <td style={tableStyles.cell}>{idx + 1}</td>

                            {/* Category */}
                            <td style={tableStyles.cell}>
                              <span>{row?.category?.category_name || "-"}</span>
                            </td>

                            {/* Sub Category */}
                            <td style={tableStyles.cell}>
                              <span>
                                {row?.sub_category?.sub_category_name || "-"}
                              </span>
                            </td>

                            {/* Item Name */}
                            <td style={tableStyles.cell}>
                              <span>{row?.item?.item_name || "-"}</span>
                            </td>

                            {/* Item Code */}
                            <td style={tableStyles.cell}>
                              <span>{row?.item_code || "-"}</span>
                            </td>

                            {/* Unit */}
                            <td style={tableStyles.cell}>
                              <span>
                                {row?.unit?.unit_name || row?.unit || "-"}
                              </span>
                            </td>

                            {/* Quantity */}
                            <td style={tableStyles.cell}>
                              <span>{row?.quantity || "-"}</span>
                            </td>

                            {/* Bags */}
                            <td style={tableStyles.cell}>
                              <div style={{ textAlign: "center" }}>
                                {row?.bags && row.bags.length > 0 ? (
                                  <VisibilityOutlinedIcon
                                    style={{
                                      color: Colors?.bg_blue,
                                      cursor: "pointer",
                                      fontSize: "1.5rem",
                                    }}
                                    onClick={() => {
                                      setViewBagsForItem(row.bags);
                                      setShow(true);
                                    }}
                                  />
                                ) : (
                                  "-"
                                )}
                              </div>
                            </td>

                            {/* Rate */}
                            <td style={tableStyles.cell}>
                              <span>{row?.rate || "-"}</span>
                            </td>

                            {/* Amount */}
                            <td style={tableStyles.cell}>
                              <span>{row.amount || "-"}</span>
                            </td>

                            {/* Discount */}
                            <td style={tableStyles.cell}>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <span>{row?.discount || "-"}</span>
                                <span>
                                  {row?.discount_type === "percentage"
                                    ? "%"
                                    : "₹"}
                                </span>
                              </div>
                            </td>

                            {/* Discount Amount */}
                            <td style={tableStyles.cell}>
                              <span>{row.discount_amount || "-"}</span>
                            </td>

                            {/* GST */}
                            <td style={tableStyles.cell}>
                              <span>{row?.gst?.gst_percent || "-"}</span>
                            </td>

                            {/* GST Amount */}
                            <td style={tableStyles.cell}>
                              <span>{row.gst_amount || "-"}</span>
                            </td>

                            {/* Total Amount */}
                            <td style={tableStyles.cell}>
                              <span>{row.total_amount || "-"}</span>
                            </td>

                            {/* Remarks */}
                            <td style={{ ...tableStyles.cell }}>
                              <OrderStatusBadge
                                status={row?.order_item_status || "-"}
                              />
                            </td>

                            <td className="remark-cell" style={tableStyles.cell}>
                              <TruncatedTextCell
                                text={row?.remark}
                                maxWidth="300px"
                                maxLines={4}
                                rowIndex={idx}
                                fallbackText="-"
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <Row className="mb-4">
              <Col lg={7} className="mb-3">
                <div
                  style={{
                    // border: `1px solid ${Colors?.grey}`,
                    borderRadius: "4px 4px 0 0",
                  }}
                >
                  <div
                    className="d-flex align-items-center gap-2 mb-0 py-2 px-1"
                    style={{
                      background: Colors?.background_color,
                      borderRadius: "6px 6px 0 0",
                    }}
                  >
                    <i
                      className="bi bi-chevron-down"
                      style={{ fontSize: "0.675rem", color: "#000" }}
                    ></i>
                    <h6 className="mb-0">Remark</h6>
                  </div>
                  <div
                    style={{
                      border: `1px solid ${Colors?.background_color}`,
                      borderRadius: "0 0 6px 6px",
                      padding: "12px",
                      minHeight: "167px",
                      height: "100%",
                      backgroundColor: "#fff",
                      color: "#212529",
                    }}
                  >
                    {data.remark || "-"}
                  </div>
                </div>
              </Col>
              <Col lg={5} className="mb-3">
                <div
                  style={{
                    backgroundColor: Colors?.background_color,
                    padding: "20px",
                    borderRadius: "8px",
                    border: `1px solid ${Colors?.background_color}`,
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Subtotal (Before Discount):
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.subtotal_before_discount)?.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Total Item Discounts:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_item_discounts)?.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Net Taxable Value:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.net_taxable_value)?.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Total GST:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_gst)?.toFixed(2)}
                    </span>
                  </div>
                  <hr style={{ margin: "12px 0", borderColor: "#90caf9" }} />
                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#212529",
                      }}
                    >
                      Total Amount:
                    </span>
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "700",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_amount)?.toFixed(2)}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="d-flex justify-content-center gap-3 py-3">
              <Button
                variant="light"
                onClick={() => navigate("/warehouse-dispatch")}
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #ced4da",
                  color: "#212529",
                  minWidth: "100px",
                }}
              >
                Back
              </Button>
            </div>
          </>
        )}
      </>

      <ViewBagsModal
        show={show}
        handleClose={() => setShow(false)}
        bags={viewBagsForItem}
      />
    </PageContainer>
  );
};

export default ViewReadyDispatchOrderDetails;
